import { useTranslations } from 'next-intl'
import styles from './DTPaymentOnHoldModal.module.css'
import Icon_PaymentOnHold from '@/assets/img/Icon_PaymentOnHold.svg'
import Icon from '@/components/UI/Icon/Icon'

export default function DTPaymentOnHoldModal () {
  const t = useTranslations('Modals.DTPaymentOnHold')

  return (
    <div className={styles.main}>
      <Icon icon={Icon_PaymentOnHold} className={styles.cardIcon} />
      <h3 className={`title3 ${styles.title}`}>{t('title')}</h3>
      <p className={`bodyTextLarge ${styles.description}`}>{t('description')}</p>
    </div>
  )
}